import XLSX from "xlsx";
import { message } from "antd";
import { getLangList } from "@/lib/i18n";
// import { numberOnlyRules } from '@/lib/validateRules';

type Data = JSON | any[] | Blob;
type DataType = 'json' | 'aoa';
type ExportParams = {
  data: Data;
  dataType?: DataType;
  headerOrder?: string[];
  bookType?: XLSX.BookType;
  workbookName: string;
  sheetName?: string;
};

export function openDownloadDialog(url: any, saveName: string) {
  if (typeof url == "object" && url instanceof Blob) {
    url = URL.createObjectURL(url); // 创建blob地址
  }
  var aLink = document.createElement("a");
  aLink.href = url;
  aLink.download = saveName || ""; // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
  let event = undefined;
  if (window.MouseEvent) {
    event = new MouseEvent("click");
  } else {
    event = document.createEvent("MouseEvents");
    event.initMouseEvent(
      "click",
      true,
      false,
      window,
      0,
      0,
      0,
      0,
      0,
      false,
      false,
      false,
      false,
      0,
      null
    );
  }
  aLink.dispatchEvent(event);
}

// 将一个sheet转成最终的excel文件的blob对象，然后利用URL.createObjectURL下载
export function sheet2blob(sheet: any, sheetName: any) {
  sheetName = sheetName || "sheet1";
  var workbook: any = {
    SheetNames: [sheetName],
    Sheets: {}
  };
  workbook.Sheets[sheetName] = sheet;
  // 生成excel的配置项
  var wopts: any = {
    bookType: sheetName, // 要生成的文件类型
    bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
    type: "binary"
  };
  var wbout = XLSX.write(workbook, wopts);
  var blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" });
  // 字符串转ArrayBuffer
  function s2ab(s: any) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  }
  return blob;
}

export const openBlobDownloadDialog = (res: any, saveName: any) => {
  const t: any = getLangList("error");
  if (res?.size === 0) {
    return message.error(t.NO_DATA);
  } else if (res?.type === 'application/json') {
    return message.error(t.UNKNOWN_ERROR);
  }
  const blob = new Blob([res], { type: "application/octet-stream" }); // xls
  const aEle = document.createElement('a'); // 创建a标签
  const href = window.URL.createObjectURL(blob);  // 创建下载的链接
  aEle.href = href;
  aEle.download = saveName || '';  // 下载后文件名
  document.body.appendChild(aEle);
  aEle.click();     // 点击下载
  document.body.removeChild(aEle); // 下载完成移除元素
  window.URL.revokeObjectURL(href); // 释放掉blob对象
  message.success(t.SUCCESS_EXPORT);
};

export const fileNameFormatTime = (menuName: string = '', tabName: string = '-') => {
  const TIME_FORMAT = new Date().toString().replace(/:/g, '_');
  const TAB_NAME = tabName !== '-'
    ? `-${tabName}-`
    : '-';
  return `${menuName}${TAB_NAME}${TIME_FORMAT}.csv`;
};

function getWorksheet(data: any, dataType: DataType, headerOrder?: string[]) {
  let workSheet: XLSX.WorkSheet;
  switch (dataType) {
    case 'json':
      workSheet = XLSX.utils.json_to_sheet(data, { header: headerOrder, skipHeader: true });
      break;
    case 'aoa':
      workSheet = XLSX.utils.aoa_to_sheet(data);
      break;
    default:
      workSheet = XLSX.utils.json_to_sheet([]);
  }
  return workSheet;
};

// [預設接收array of array，匯出csv檔]
export function exportExcel({
  data,
  dataType = 'aoa',
  headerOrder = [],
  bookType = 'csv',
  workbookName = 'noName',
  sheetName = 'sheet1',
}: ExportParams) {
  const t: any = getLangList("error");
  if ((dataType === 'aoa' || dataType === 'json') && Array.isArray(data) && data.length === 1) {
    return message.error(t.NO_DATA);
  }
  const workBook = XLSX.utils.book_new(); // 創建一個新的工作簿
  const workSheet = dataType === 'json'
    ? getWorksheet(data, dataType, headerOrder)
    : getWorksheet(data, dataType);

  // 解決字串開頭是0的時候，excel會自動格式化去掉的問題
  // for (let key in workSheet) {
  //   const cellValue = workSheet[key]['v'];
  //   if (typeof cellValue === 'string' && numberOnlyRules.test(cellValue) && cellValue) {
  //     // workSheet[key]['v'] = `="${cellValue}"`;
  //     workSheet[key]['v'] = `\r\n${cellValue}\r\n`;
  //   }
  // }

  XLSX.utils.book_append_sheet(workBook, workSheet, sheetName); // 向工作簿追加一個工作表
  const result = XLSX.write(workBook, { // 寫入文件
    type: 'array', // 輸出的數據類型
    bookType, // 輸出的文件類型
  });
  openBlobDownloadDialog(result, `${workbookName}.${bookType}`);
};